export const CollectionItemConfig = {
  noteMaxLength: 9000,
  descriptionMaxLength: 9000,
  whereStoredMinLength: 0,
  whereStoredMaxLength: 255,
  acquisitionSourceMin: 0,
  acquisitionSourceMax: 255,
  nameMinLength: 1,
  nameMaxLength: 450,
  acquirePriceMin: 0,
  acquirePriceMax: 42949672.95,
  currentPriceMin: 0,
  currentPriceMax: 42949672.95,
  piecesMin: 0, // Can be zero, because all pieces can be in marketplace
  piecesMax: 9999,
};
